import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BranchLink from "web/react/components/branch-link/branch-link";
import MultiplyOnHoverButton from "web/react/components/buttons/multiply-on-hover-button/multiply-on-hover-button";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import analytics from "web/script/analytics/analytics";
import environment from "web/script/modules/environment";
import requester from "web/script/modules/requester";
import { RawBranchLink } from "web/script/utils/branch-io";
import browser from "web/script/utils/browser";

interface FollowDesignerButtonProps {
    lystId: number;
    followedText: string;
    notFollowedText: string;
    isAuthenticated: string;
    isFollowing: string;
    openCustomerCaptureOverlay: (object) => void;
    analyticsParameters: [string, string, string];
    className: string;
}

export function FollowDesignerButton({
    lystId,
    followedText,
    notFollowedText,
    isAuthenticated,
    isFollowing,
    openCustomerCaptureOverlay,
    analyticsParameters,
    className,
}: FollowDesignerButtonProps): JSX.Element {
    const [following, setFollowing] = useState<boolean>(isFollowing != "false");
    const [isIos, setIsIos] = useState(false);

    useEffect(() => {
        setIsIos(browser.ios);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [browser.ios]);

    function follow(): Promise<void> {
        return requester
            .post("/api/users/add/", `lyst_id=${lystId}`)
            .then(() => {
                setFollowing(true);
                analytics.event("Follow Button", "Follow - Success", undefined, true);
            })
            .catch(() => {
                analytics.event("Follow Button", "Follow - Error", undefined, true);
            });
    }

    function unFollow(): Promise<void> {
        return requester
            .post("/api/users/remove/", `lyst_id=${lystId}`)
            .then(() => {
                setFollowing(false);
                analytics.event("Follow Button", "Unfollow - Success", undefined, true);
            })
            .catch(() => {
                analytics.event("Follow Button", "Unfollow - Error", undefined, true);
            });
    }

    const pageSubType = environment.get("pageSubType");
    let buttonLabel = following ? followedText : notFollowedText;

    const [category, action, label] = analyticsParameters;

    function onClick(): void {
        analytics.event(category, action, label);
        if (isAuthenticated === "false") {
            openCustomerCaptureOverlay({
                designerId: lystId,
                captureType: "signup_du",
            });
        } else if (following) {
            unFollow();
        } else {
            follow();
        }
    }

    if (
        pageSubType &&
        pageSubType.startsWith("designer") &&
        isAuthenticated === "false" &&
        isIos &&
        (environment.getFeature("mg_du_banner_ios_to_app") ||
            environment.getFeature("mg_enable_top_and_du_banners"))
    ) {
        return (
            <BranchLink
                title={buttonLabel}
                className={className}
                branchLink={RawBranchLink.DesignerUpdates}
                eventLabel={"follow_designer_button"}
                primaryButton
            />
        );
    }

    return (
        <MultiplyOnHoverButton
            className={className}
            onClick={onClick}
            disabled={false}
            fullWidth={false}
            fullHeight={false}
            openInNewTab={false}
        >
            {buttonLabel}
        </MultiplyOnHoverButton>
    );
}

export default connect(null, { openCustomerCaptureOverlay })(FollowDesignerButton);
